import { jsx as _jsx } from "react/jsx-runtime";
import { PropertyLine } from "./propertyLine";
import { SpinButton } from "../../primitives/spinButton";
import { makeStyles, mergeClasses } from "@fluentui/react-components";
import { UniformWidthStyling } from "../../primitives/utils";
const useStyles = makeStyles({
    uniformWidth: {
        ...UniformWidthStyling,
    },
});
export const SpinButtonPropertyLine = (props) => {
    SpinButtonPropertyLine.displayName = "SpinButtonPropertyLine";
    const classes = useStyles();
    return (_jsx(PropertyLine, { ...props, children: _jsx(SpinButton, { ...props, className: mergeClasses(classes.uniformWidth, props.className) }) }));
};
//# sourceMappingURL=spinButtonPropertyLine.js.map